import { useState } from 'react'
import type { BlockAlternativ, VisatBlock } from '../types'
import { BLOCK_TYP_ETIKETT } from '../lib/lektionsplanering'
import { Figurer } from './Figurer'
import InstansVy from './InstansVy'
import Tavelvy from './Tavelvy'

/** Ett block i en lektions uppläggning: typ-badge, namn, tidsåtgång och den
 *  ämnesspecifika instansen i fokus. Har blocket en helskärmstext (det som
 *  eleverna ska se på tavlan) finns en "Visa på tavlan"-knapp som öppnar den
 *  i stor, avskalad helskärm. Blockets generiska metodbeskrivning, pedagogiska
 *  källa och (för flex-block) biblioteksutbytbarhet ligger bakom en utfällning.
 *  Tekniska referenser (block-id, versionsnummer) visas INTE i läsvyn — de hör
 *  till datalagret (STRUKTUR-OCH-WEBBPRESENTATION.md §7). */
export default function BlockKort({
  block,
  nummer,
  ersattningsbar_med = [],
}: {
  block: VisatBlock
  nummer?: number
  ersattningsbar_med?: BlockAlternativ[]
}) {
  const [tavla, setTavla] = useState(false)

  // Instansen kan i en gammal, osynkad ögonblicksbild fortfarande vara en
  // textsträng — då finns inga steg att hämta figurer ur.
  const instans = block.amnesspecifik_instans
  const stegfigurer =
    typeof instans === 'object' && instans !== null ? instans.steg.flatMap((s) => s.illustrationer) : []

  return (
    <div className={`blockkort blockkort-${block.typ}`}>
      <div className="blockkort-huvud">
        {nummer !== undefined && <span className="blockkort-nr">{nummer}</span>}
        <span className={`blocktyp-badge blocktyp-badge-${block.typ}`}>{BLOCK_TYP_ETIKETT[block.typ] ?? block.typ}</span>
        <h4>{block.namn}</h4>
        {block.helskarm_text && (
          <button type="button" className="knapp knapp-sekundar knapp-liten no-print" onClick={() => setTavla(true)}>
            🖥 Visa på tavlan
          </button>
        )}
        <span className="blockkort-tid">{block.varaktighet_min} min</span>
      </div>
      {block.amnesspecifik_instans && <InstansVy instans={block.amnesspecifik_instans} />}
      <details className="blockkort-detaljer">
        <summary>Om metoden{ersattningsbar_med.length > 0 && ' · kan bytas'}</summary>
        <p className="blockkort-generisk">{block.generisk_beskrivning}</p>
        {block.kalla_pedagogisk_metod && (
          <p className="blockkort-kalla">
            <strong>Pedagogisk metod: </strong>
            {block.kalla_pedagogisk_metod}
          </p>
        )}
        {ersattningsbar_med.length > 0 && (
          <p className="blockkort-alternativ">
            <strong>Kan bytas mot: </strong>
            {ersattningsbar_med.map((alt) => alt.namn).join(' · ')}
          </p>
        )}
      </details>

      {tavla && block.helskarm_text && (
        <Tavelvy rubrik={block.namn} onStang={() => setTavla(false)}>
          <div className="tavelvy-text">{block.helskarm_text}</div>
          {/* Figurerna ur stegen följer med upp på tavlan. Utan dem blir en
              bildimpuls "Titta på bilden" utan bild — momentets hela poäng.
              Visningsmärkningen stannar i lärarvyn. */}
          <Figurer illustrationer={stegfigurer} />
        </Tavelvy>
      )}
    </div>
  )
}
